import React from "react";

type headingType = {
  heading: string;
  className?: string;
};

export default function SectionHeading({ heading, className }: headingType) {
  return <h2 className={`font-medium text-lg sm:text-xl text-primaryBlack ${className}`}>{heading}</h2>;
}
